import React from 'react';
import SinglePageContainer from '../../Common/SinglePageContainer';
import InviteUsersTable from './Table';
import FormInviteUsers from './Form';
import EmailsQueue from './EmailsQueue';

export default function InviteUsers(): React.ReactNode {
  return (
    <SinglePageContainer
      title="Invite Users"
      breadcrumbItems={[]}
      stickyHeader
    >
      <EmailsQueue />
      <FormInviteUsers />
      <InviteUsersTable />
    </SinglePageContainer>
  );
}
